import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HighlightedItemsService from 'services/HighlightedItemsService';
import CustomIcon from 'components/commons/CustomIcon';
import Loading from 'components/LoadingPage';
import translate from 'locales/i18n';
import Facade from 'core/Facade';
import AlertAction from 'actions/AlertAction';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//Style
import useStyles from 'components/page/HighlightsItemsPage/HighlightsItems.style';

const HighlightsItems = () => {
    const classes = useStyles();

    const [data, setData] = useState(null);
    const [status, setStatus] = useState(null);
    const [date, setDate] = useState(new Date(Facade.getTodayDateStr()));

    useEffect(() => {
        if (status) {
            HighlightedItemsService.gethighlightedItems(status, `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`)
                .then(result => {
                    setData(result);
                }, response => {
                    if (response && response.error) AlertAction.open('error', translate.i18n(response.error), 'top-right');
                    setData([]);
                });
        } else {
            setStatus('GREATEST_DECREASES_IN_PERCENTAGE');
        }
    }, [status, date]);

    const handleDateChange = (value) => {
        setDate(value);
    };

    const createData = (siteName, currency, taxMode, url, priceBefore, priceAfter, priceEvolutionPercent, priceEvolutionValue, account, productName) =>
        ({ siteName, currency, taxMode, url, priceBefore, priceAfter, priceEvolutionPercent, priceEvolutionValue, account, productName });

    const renderButtons = () => {
        const values = ['GREATEST_DECREASES_IN_PERCENTAGE', 'GREATEST_DECREASES_IN_VALUE', 'GREATEST_INCREASES_IN_PERCENTAGE', 'GREATEST_INCREASES_IN_VALUE'];
        return <>
            {
                values.map((value, key) =>
                    <Button key={key} className={classes.statusChooseElement} variant={status === value ? 'contained' : null} color='primary' onClick={() => {
                        setData(null); setStatus(value);
                    }}>
                        {translate.i18n(value)}
                    </Button>)
            }
        </>;
    };
    const renderTable = (sites) => {
        const rows = [];
        sites.forEach(values => rows.push(createData(
            values.site_name,
            values.site_currency_symbol,
            values.site_tax_mode,
            values.url,
            values.price_before,
            values.price_after,
            values.price_evolution_in_percent,
            values.price_evolution_in_value,
            values.associated_articles[0].account_name,
            values.associated_articles[0].article_name

        )));
        return <>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label='simple table'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Site</TableCell>
                            <TableCell>Product name</TableCell>
                            <TableCell>Account</TableCell>
                            <TableCell>Currency</TableCell>
                            <TableCell>Tax mode</TableCell>
                            <TableCell>Url</TableCell>
                            <TableCell>Before(Raw)</TableCell>
                            <TableCell>After(Raw)</TableCell>
                            <TableCell>Price Evolution in %</TableCell>
                            <TableCell>Price Evolution in value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, key) =>
                            <TableRow key={key}>
                                <TableCell>{row.siteName}</TableCell>
                                <TableCell>{row.productName}</TableCell>
                                <TableCell>{row.account}</TableCell>
                                <TableCell>{row.currency}</TableCell>
                                <TableCell>{row.taxMode}</TableCell>
                                <TableCell>
                                    <a href={row.url} target='_blanck'>
                                        <CustomIcon className='fas fa-link' style={{ fontSize: '20px', color: 'black', width: '25px', height: '25px' }} />
                                    </a>
                                </TableCell>
                                <TableCell>{row.priceBefore}</TableCell>
                                <TableCell>{row.priceAfter}</TableCell>
                                <TableCell>{row.priceEvolutionPercent}</TableCell>
                                <TableCell>{row.priceEvolutionValue}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>;
    };

    return <>
        <div className={classes.tableContainer}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    renderInput={(props) => <TextField {...props} size='small' classes={{ root: classes.datePicker }} />}
                    label='Date'
                    value={date}
                    onChange={(newValue) => {
                        handleDateChange(newValue);
                    }}
                    inputVariant='outlined'
                    inputFormat='dd/MM/yyyy'
                    margin={'dense'}
                />
            </LocalizationProvider>
            <div className={classes.statusChooseContainer}>
                {renderButtons()}
            </div>
            {data
                ? renderTable(data)
                : <Loading />}
        </div>
    </>;
};

export default HighlightsItems;
